module.exports = __webpack_public_path__ + "static/img/wechat.9ac2e46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat.jpg
// module id = N6av
// module chunks = 38